import React from 'react';
import { useStyles } from '../../../pages/styles';

const GridMenu: React.FC = (props) => {
  const globalStyle = useStyles();

  return <div className={globalStyle.gridMenu}>{props.children}</div>;
};

export default GridMenu;
